import { ref, toValue, watch } from 'vue'
import useCurrentURL from './useCurrentURL.ts'

export function useQueryParameter(name: string, defaultValue: string | null = null) {
  const { query } = useCurrentURL()

  const value = ref<string | number | null>(query.value[name] ?? defaultValue)

  watch(value, () => {
    const paramValue = toValue(value)
    if (paramValue === null) {
      delete query.value[name]
    } else {
      query.value[name] = String(paramValue)
    }
  })

  return {
    value,
  }
}
